import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col">Gallereasy POC web app</div>
          <div className="col text-right">2359 Media</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
